@if (notifications?.length !== 0) {
  <div class="notifications" [ngClass]="['notifications--' + (position$ | async)]" [@animateToasts]>
    @for (notification of notifications; track notification.id; let i = $index) {
      <div class="notification" [ngClass]="['notification--' + notification.style]" [@animateToasts]>
        <!-- eslint-disable @angular-eslint/template/no-inline-styles -->
        <div
          class="notification__bar"
          [style.animationDuration]="(notification.duration || defaultDuration) + 'ms'"
        ></div>
        <mat-icon
          class="notification__close"
          (click)="removeNotification(i)"
          icon="exp-cross"
          height=".6em"
          width=".6em"
        />
        <div class="notification-message">
          @if (notification.style) {
            <div class="notification-message__picto">
              @if (notification.style === NotifStatus.Success) {
                <mat-icon svgIcon="exp-valid" width="1.5em" />
              }
              @if (notification.style === NotifStatus.Failed) {
                <mat-icon svgIcon="exp-alert" width="1.5em" />
              }
            </div>
          }
          <div class="notification-message__content">
            <p [innerHTML]="notification.message"></p>
          </div>
        </div>
        @if (notification.callbackConfig) {
          <button class="btn-clean notification__button" type="button">
            {{ notification.callbackConfig.text }}
          </button>
        }
      </div>
    }
  </div>
}
